import { createSelector } from '~/helpers/util/selectors';
import { DeliveryPatternState } from './duck';

export const getRoot = (state: any) => {
  return state.core.deliveryPattern as DeliveryPatternState;
};
export const getDeliveryPatternsById = createSelector([getRoot], state => {
  return state.deliveryPatternsById;
});
